import React, { ChangeEvent, useCallback } from 'react';
import componentStyles from 'styles/partials/_baseinput.css';

export type IDisplayListSimpleProps = {
  onChange: (value: Array<string>) => void;
  value: Array<string>;
  readOnly?: boolean;
  label?: string;
};

const DisplayListSimple = ({ onChange, value, readOnly, label }: IDisplayListSimpleProps) => {
  const renderLine = useCallback(
    (valueEntry: string, key: number) => {
      const changeValue = (key: number, event: ChangeEvent<any>) => {
        const newValue = event.target.value;
        const list = [...value];

        if (newValue === '' && key > 0) {
          list.splice(key, 1);
        } else {
          list[key] = newValue;
        }
        onChange(list);
      };

      return (
        <div key={`alias${key}`} className={componentStyles.inputGroup}>
          <div className={componentStyles.inputContainer}>
            <input
              data-testid={`${key}`}
              type="text"
              className={componentStyles.inputControl}
              key={key}
              onChange={(event) => changeValue(key, event)}
              value={valueEntry}
              disabled={!!readOnly}
            />
          </div>
        </div>
      );
    },
    [onChange, readOnly, value]
  );

  const valueList = value ? [...value, ''] : [''];
  const dataList = valueList.map((valueEntry, key) => {
    return renderLine(valueEntry, key);
  });

  return (
    <div>
      {label && <label className={componentStyles.inputLabel}>{label}</label>}
      {dataList}
    </div>
  );
};

DisplayListSimple.defaultProps = {
  value: [],
};

export default DisplayListSimple;
